import {SubstanceDrawer} from '@/modules/drug-catalog/substances/components/active-substance-drawer/substance-drawer'
import {drawer} from '@cypro/ui/components'
import {ActiveSubstanceDrugProvider} from '@/shared/contexts/active-substance-drug'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {Suspense} from 'react'

export function getActiveSubstanceDrawerId(substanceId: string) {
  return `substance-drawer-${substanceId}`
}

export function openActiveSubstanceDrawer(substance: DrugCatalogItem) {
  const id = getActiveSubstanceDrawerId(substance.id)
  return drawer.open(id, {
    id,
    children: (
      <Suspense>
        {substance && (
          <ActiveSubstanceDrugProvider activeSubstanceDrug={substance}>
            <SubstanceDrawer />
          </ActiveSubstanceDrugProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'active-substance-drawer',
    },
    size: 'lg',
  })
}
